export const setMpWxStorage = (key: string, val: string) => {
  wx.setStorageSync(key, val);
};
export const getMpWxStorage = (key: string) => {
  return wx.getStorageSync(key);
};
